/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Membership_Option_Remove_DescriptionInputs */

const fr_membership_option_remove_description = /** @type {(inputs: Membership_Option_Remove_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votre accès 6h-23h restera actif jusqu'au ${i?.date}, sans remboursement pour la période en cours.`)
};

/**

* @param {Membership_Option_Remove_DescriptionInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_option_remove_description = /** @type {((inputs: Membership_Option_Remove_DescriptionInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Option_Remove_DescriptionInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_option_remove_description(inputs)
});